import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  email: "",
  sns_email: "",
  user_type: 1,
  plan_num: 1,
  name: "",
  name_kana: "",
  sex: 1,
  birth_date: "",
  restaurant_name: "",
  postal_code: "",
  large_location: "",
  medium_location: "",
  state: "",
  city: "",
  street_address: "",
  phone_num: "",
  biz_large_category: "",
  biz_medium_category: "",
  business_scale: "",
  business_area: "",
  lunch_menu: 1,
  average_spending: "",
  seats: "",
  website_url: "",
  email_notification: 0,
  paying_by: "",
  start_from: ""
};

const userModule = {
  actions: {
    emailCheck({ commit }, { email, excludedId = undefined }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .post(`/users/emailcheck`, {
            email,
            excludedId
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {}
};

const entityModule = entity("users", initialEntity);

export const users = {
  namespaced: true,
  modules: {
    list: list("users"),
    entity: concatModules(entityModule, userModule)
  }
};
